/**
 * Pure index arithmetic for cyclic keyboard navigation (focus traps, list
 * roving). DOM-free so it is unit-testable; the DOM trap in `trap-focus.ts`
 * builds on these. An empty list is always a no-op (`-1`).
 */

/** Next index in a wrapping ring; `-1` when the list is empty. */
export function nextIndex(current: number, length: number): number {
  if (length <= 0) return -1;
  return (Math.max(current, -1) + 1) % length;
}

/** Previous index in a wrapping ring; `-1` when the list is empty. */
export function prevIndex(current: number, length: number): number {
  if (length <= 0) return -1;
  const base = current < 0 ? 0 : current;
  return (base - 1 + length) % length;
}
